import ToastNotification from "./toast-notification";
import React from "react";

export interface ToastNotificationBuiltinsProps {
	onDismiss?: () => void;
}

export function ToastNotificationNoInternet(
	props: ToastNotificationBuiltinsProps,
) {
	return (
		<ToastNotification
			type="error"
			title="No internet connection"
			onDismiss={props.onDismiss}
		>
			Live data will not be displayed until a connection is restored.
		</ToastNotification>
	);
}

export function ToastNotificationExternalError(
	props: ToastNotificationBuiltinsProps,
) {
	return (
		<ToastNotification
			type="error"
			title="Error retrieving data"
			onDismiss={props.onDismiss}
		>
			The latest information could not be loaded. Please try again later.
		</ToastNotification>
	);
}

export function ToastNotificationNoContent(
	props: ToastNotificationBuiltinsProps,
) {
	return (
		<ToastNotification
			type="error"
			title="Content error"
			onDismiss={props.onDismiss}
		>
			The requested content is no longer available.
		</ToastNotification>
	);
}
